import React, { ReactElement } from "react";

export interface IGenericInsuranceIconsProps {
	icon:
		| "home"
		| "cyber"
		| "fire"
		| "crop"
		| "marine"
		| "commercial"
		| "fp"
		| "tax"
		| "goals"
		| "accumulate"
		| "loan"
		| "peace"
		| "coverage"
		| "claims"
		| "premiums";
	style?: React.CSSProperties;
}

export default function GenericInsuranceIcons(props: IGenericInsuranceIconsProps): ReactElement {
	switch (props.icon) {
		case "home":
			return (
				<svg xmlns="http://www.w3.org/2000/svg" id="Home" width="44" height="44" viewBox="0 0 44 44" style={props.style}>
					<g id="Home-2" transform="translate(0 7)">
						<g id="Group_3430">
							<path id="Rectangle_1111" d="M0 0H3.075V8.678H0z" fill="#003f87" transform="translate(8.014 .425)" />
							<path
								id="Path_1143"
								d="M-31.618 33.9h3.075v-9.608a2.782 2.782 0 0 0-2.768-2.792h-7.379a2.782 2.782 0 0 0-2.767 2.789V33.9h3.075v-9.3h6.764z"
								fill="#003f87"
								transform="translate(55.003 -.002)"
							/>
							<path
								id="Path_1144"
								d="M-17.015 18.419l2.008-2.345L-32.4.974a3.972 3.972 0 0 0-5.206 0l-17.4 15.1L-53 18.419l1.195-1.03.509-.443V33.9h3.074V14.268l.106-.092 12.5-10.887a.917.917 0 0 1 1.2 0l12.52 10.889.106.093V33.9h3.074V16.944l.509.442z"
								fill="#fc3f00"
								transform="translate(55.007 -.002)"
							/>
							<path id="Path_1145" d="M-28.24 33.9h-25.515V37h37.5v-3.1z" fill="#fc3f00" transform="translate(55.007 -.002)" />
						</g>
					</g>
					<path id="Rectangle_1121" fill="none" d="M0 0H44V44H0z" />
				</svg>
			);
		case "cyber":
			return (
				<svg xmlns="http://www.w3.org/2000/svg" id="Cyber" width="44" height="44" viewBox="0 0 44 44" style={props.style}>
					<g id="Cyber-2" transform="translate(0 10)">
						<path id="Rectangle_1114" fill="#003f87" d="M0 0H3.968V4.643H0z" transform="translate(19.178 24.614)" />
						<path
							id="Path_1153"
							d="M21.257 20.055a13.967 13.967 0 0 0-10.336 5.067l2.533 3.268a10.674 10.674 0 0 1 7.82-3.551 10.688 10.688 0 0 1 7.839 3.551l2.537-3.272a13.552 13.552 0 0 0-10.06-5.063z"
							fill="#fc3f00"
							transform="translate(-.117 -7.539)"
						/>
						<path
							id="Path_1154"
							d="M21.164 7.539C13.339 7.6 5.7 11.35.117 17.846l2.652 3.269c4.974-5.718 11.5-8.887 18.447-8.937h.124c6.949.049 13.478 3.218 18.451 8.937l2.653-3.27c-5.526-6.47-13.1-10.218-20.868-10.306z"
							fill="#fc3f00"
							transform="translate(-.117 -7.539)"
						/>
					</g>
					<path id="Rectangle_1122" fill="none" d="M0 0H44V44H0z" />
				</svg>
			);
		case "fire":
			return (
				<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" style={props.style}>
					<g>
						<path
							fill="#003f87"
							d="M20.225 18.952a.4.4 0 0 0-.425-.052l-1.5.689a.4.4 0 0 0-.219.466c.058.229 1.367 5.676-1.509 8.684-1.926 2.016-2.448 4.277-1.432 6.2.01.019 1.082 2.009 2.129 2.288a6.661 6.661 0 0 0 1.717.239h.055a4.477 4.477 0 0 0 1.157-.152 6.991 6.991 0 0 0 3.529-2.205 9.953 9.953 0 0 0 2.246-6.375c.007-4.992-5.513-9.588-5.748-9.782zM19.09 35.011h-.044a2.367 2.367 0 0 1-1.594-1.106c-.34-.591-.648-1.859 1.1-3.689a10.122 10.122 0 0 0 2.481-6.9c1.129 1.43 2.361 3.444 2.361 5.417 0 3.8-2.294 6.134-3.867 6.29-.1 0-.2 0-.3-.009z"
							transform="translate(0 6) translate(-4.534 .158)"
						/>
						<path
							fill="#fc3f00"
							d="M36.683 21.352a20.7 20.7 0 0 0-6.7-13.536 1.533 1.533 0 0 0-2.141.086 1.482 1.482 0 0 0-.342 1.417c.523 1.808.455 2.979-.247 3.95-1.136-5.381-3.722-8.562-6.986-12.577l-.21-.257A1.531 1.531 0 0 0 17.927.2a1.49 1.49 0 0 0-.555 1.352A12.875 12.875 0 0 1 15.176 11a28.1 28.1 0 0 0-2.4 4.181 12.276 12.276 0 0 1-1.125-3.856 1.483 1.483 0 0 0-.6-.976 1.536 1.536 0 0 0-1.126-.272 1.515 1.515 0 0 0-1.071.708c-3.647 5.983-6.7 14.7-.539 22.282a1.624 1.624 0 0 0 .113.126 16.6 16.6 0 0 0 11.541 4.68h.308a21.491 21.491 0 0 0 6.7-1.1 14.364 14.364 0 0 0 9.782-12.616 15.169 15.169 0 0 0-.076-2.805zm-22.7 12.285L14 33.6l-.015.039zm-3.344-2.488c-3.384-4.206-3.708-9.412-.966-15.479a5.956 5.956 0 0 0 3.2 3.634 1.528 1.528 0 0 0 1.16-.032 1.492 1.492 0 0 0 .8-.83 1.365 1.365 0 0 0 .055-.165 18.575 18.575 0 0 1 2.826-5.643A16.151 16.151 0 0 0 20.4 5.706a19.99 19.99 0 0 1 4.26 10.648 1.521 1.521 0 0 0 2.372 1.074 8.107 8.107 0 0 0 3.6-4.318 18.683 18.683 0 0 1 3.041 8.583 12.343 12.343 0 0 1 .061 2.268c-.343 5.128-3.384 8.4-6.253 9.372a19.457 19.457 0 0 1-13.456.185 9.846 9.846 0 0 1-3.387-2.37z"
							transform="translate(0 6) translate(-4.792 .125)"
						/>
					</g>
					<path fill="none" d="M0 0H44V44H0z" />
				</svg>
			);
		case "crop":
			return (
				<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" style={props.style}>
					<g>
						<path
							fill="#fc3f00"
							d="M-78.95-13.208h.121a3.208 3.208 0 0 0 .779-.1 9.081 9.081 0 0 0 7.914-10l-.005-.045-.085-.805-.677-.354a9.528 9.528 0 0 0-1.256-.459l-.213-.061.143-.176a9.579 9.579 0 0 0 2.089-6.913l-.085-.795-.677-.354a8.525 8.525 0 0 0-3.678-.831 8.6 8.6 0 0 0-5.128 1.701 8.79 8.79 0 0 0-.917.791l-.236.234v-.22h-2.516v.263l-.236-.234A8.581 8.581 0 0 0-89.68-34.1a8.432 8.432 0 0 0-3.658.832l-.672.351-.085.8v.956A9.407 9.407 0 0 0-92-25.213l.143.176-.213.061a8.708 8.708 0 0 0-1.272.47l-.671.351-.085.8v.957a9.017 9.017 0 0 0 8.807 9.194 8.131 8.131 0 0 0 1.741-.191l.169-.038v5.266h2.516v-5.266l.169.038a8.131 8.131 0 0 0 1.746.187zm-12.532-17.8a5.834 5.834 0 0 1 1.873-.309 5.873 5.873 0 0 1 3.565 1.2 6.657 6.657 0 0 1 2.644 4.859v.339l-.093.035a4.675 4.675 0 0 1-1.608.293c-.1.006-.208.009-.317.009a5.755 5.755 0 0 1-.89-.069 7.155 7.155 0 0 1-1.585-.494 6.476 6.476 0 0 1-3.686-5.717v-.11zm8.082 14.843l-.089.037a3.843 3.843 0 0 1-1.478.294h-.043c-.109.007-.228.01-.346.01a6.36 6.36 0 0 1-6.221-6.145l-.006-.136v-.106l.094-.037a4.322 4.322 0 0 1 1.586-.3h.045c.092 0 .183-.006.275-.006a6.341 6.341 0 0 1 6.183 6.023v.365zm2.53-8.755l.005-.113a6.654 6.654 0 0 1 2.668-5.078 5.976 5.976 0 0 1 3.658-1.269 5.861 5.861 0 0 1 1.776.275l.1.031v.108a4.851 4.851 0 0 1-.289 1.707 6.332 6.332 0 0 1-3.448 4.114 8.714 8.714 0 0 0-1.442.45 5.754 5.754 0 0 1-1.083.1 5.942 5.942 0 0 1-1.843-.294zm.027 8.763v-.192-.145a6.664 6.664 0 0 1 2.645-4.86 5.979 5.979 0 0 1 3.658-1.27 5.862 5.862 0 0 1 1.776.276l.109.035-.01.119a9.374 9.374 0 0 1-.284 1.583A6.4 6.4 0 0 1-79-15.873a6.077 6.077 0 0 1-1.733-.254z"
							transform="translate(0 6) translate(94.096 46.172)"
						/>
						<path
							fill="#003f87"
							d="M-82.143-29.987l-.744-.372a8.961 8.961 0 0 1-3.348-12.185A7.853 7.853 0 0 1-82.98-45.8l.744-.372.745.372a8.962 8.962 0 0 1 3.348 12.186 7.845 7.845 0 0 1-3.257 3.255zm-.093-13.022a6.1 6.1 0 0 0-1.1 8.554l.076.1a12.775 12.775 0 0 0 1.116 1.116 6.2 6.2 0 0 0 1.117-8.651 4.548 4.548 0 0 0-1.21-1.116z"
							transform="translate(0 6) translate(94.119 46.172)"
						/>
					</g>
					<path fill="none" d="M0 0H44V44H0z" />
				</svg>
			);
		case "marine":
			return (
				<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" style={props.style}>
					<g>
						<path
							fill="#fc3f00"
							d="M-41.338-22.193a1.62 1.62 0 0 0-.56.457 1.594 1.594 0 0 0-.3.653 1.565 1.565 0 0 0 .031.71 15.014 15.014 0 0 0 5.373 7.808 14.927 14.927 0 0 0 9.072 3.043 14.924 14.924 0 0 0 9.071-3.043 15 15 0 0 0 5.372-7.81 1.536 1.536 0 0 0 .03-.71 1.586 1.586 0 0 0-.295-.651 1.6 1.6 0 0 0-.56-.457 1.623 1.623 0 0 0-.708-.164h-3.321a1.615 1.615 0 0 0-1.129.46 1.569 1.569 0 0 0-.464 1.1 1.547 1.547 0 0 0 .464 1.1 1.612 1.612 0 0 0 1.129.461h1.033l-.2.374a11.868 11.868 0 0 1-3.478 3.944 12.1 12.1 0 0 1-5.055 2.091l-.294.048v-17.178h6.371a1.6 1.6 0 0 0 1.127-.46 1.547 1.547 0 0 0 .465-1.1 1.572 1.572 0 0 0-.466-1.106 1.61 1.61 0 0 0-1.127-.459h-6.37v-3.091h-3.183v3.091h-6.366a1.611 1.611 0 0 0-1.127.46 1.576 1.576 0 0 0-.465 1.106 1.546 1.546 0 0 0 .465 1.1 1.6 1.6 0 0 0 1.128.46h6.368v17.186l-.294-.048a12.079 12.079 0 0 1-5.054-2.093 11.879 11.879 0 0 1-3.477-3.942l-.2-.374h1.115a1.594 1.594 0 0 0 1.127-.46 1.543 1.543 0 0 0 .465-1.1 1.565 1.565 0 0 0-.465-1.1 1.582 1.582 0 0 0-1.119-.46h-3.415a1.646 1.646 0 0 0-.714.154z"
							transform="translate(0 7) translate(42.22 45.889)"
						/>
						<path
							fill="#003f87"
							d="M-23.426-38.248a4.857 4.857 0 0 0 .747-3.386 4.926 4.926 0 0 0-1.706-3.041 5.211 5.211 0 0 0-3.341-1.214 5.213 5.213 0 0 0-3.341 1.214 4.936 4.936 0 0 0-1.706 3.042 4.854 4.854 0 0 0 .748 3.386 5.113 5.113 0 0 0 2.579 2l.171.059v.013h3.1v-.013l.17-.059a5.116 5.116 0 0 0 2.579-2.001zm-2.439-1.9a1.956 1.956 0 0 1-.739.88l-.063.041h-.007a2.073 2.073 0 0 1-1.04.279 2.069 2.069 0 0 1-1.42-.561 1.969 1.969 0 0 1-.595-1.392 1.923 1.923 0 0 1 .34-1.1 1.986 1.986 0 0 1 .9-.722 2.067 2.067 0 0 1 .765-.149 2.124 2.124 0 0 1 .391.038 2.01 2.01 0 0 1 1.028.538 1.906 1.906 0 0 1 .551 1.007 1.9 1.9 0 0 1-.111 1.145z"
							transform="translate(0 7) translate(42.22 45.889)"
						/>
					</g>
					<path fill="none" d="M0 0H44V44H0z" />
				</svg>
			);
		case "commercial":
			return (
				<svg xmlns="http://www.w3.org/2000/svg" id="Commercial" width="44" height="44" viewBox="0 0 44 44" style={props.style}>
					<g id="Commercial-2" transform="translate(0 9)">
						<path
							id="Path_1157"
							d="M7.366-39.583l-4.243 7.648v4.1l3.035 1.279 3.037-1.275v-5.094h3.155v5.1l3.035 1.281 3.034-1.283v-5.094h3.156v5.1l3.035 1.28 3.036-1.281v-5.1H30.8v5.1l3.036 1.281 3.036-1.281v-4.1l-4.244-7.649z"
							fill="none"
							transform="translate(-.217 42.465)"
						/>
						<path
							id="Path_1159"
							fill="#fc3f00"
							d="M39.784-25.925v-6.709l-5.435-9.831H5.647L.236-32.709l-.019 6.785 4.46 1.882.153.064v14.556h30.34v-14.557l.153-.064zm-7.523 13.871H7.486v-11.925l.153-.064 3.033-1.28.1-.041.1.041 4.516 1.905 4.512-1.905.1-.041.1.041 4.516 1.905 4.516-1.9.1-.041.1.041 3.035 1.28.153.064v.166L32.511-12.3v.25zm1.676-14.266l-.1.041-.1-.041L30.7-27.6l-.153-.064v-5.014H27.9v5.014l-.153.064-3.036 1.279-.1.041-.1-.041L21.48-27.6l-.153-.064v-5.014H18.67v5.014l-.153.064-3.035 1.279-.1.041-.1-.041-3.026-1.279-.153-.064v-5.014h-2.66v5.014l-.153.064-3.035 1.279-.1.041-.1-.041L3.026-27.6l-.153-.064V-32l.031-.056L7.147-39.7l.072-.128h25.559l.071.128 4.244 7.649.031.056v4.331l-.152.065z"
							transform="translate(-.217 42.465)"
						/>
						<path
							id="Path_1160"
							fill="#003f87"
							d="M24.373-12.154h2.656v-6.554H13.963v6.555h2.656v-3.924h7.753v3.923z"
							transform="translate(-.217 42.465)"
						/>
					</g>
					<path id="Rectangle_1126" d="M0 0H44V44H0z" fill="none" />
				</svg>
			);
		case "fp":
			return (
				<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" style={props.style}>
					<g>
						<path fill="none" d="M0 0H60V60H0z" transform="translate(-290 -2064) translate(290 2064)" />
						<g>
							<path
								fill="#fc3f00"
								d="M36.692 7.319L19.888.189a2.287 2.287 0 0 0-1.778 0l-16.8 7.13A2.1 2.1 0 0 0 0 9.245V23.4a23.334 23.334 0 0 0 12.656 20.54l5.282 2.8a2.656 2.656 0 0 0 1.069.263 2.274 2.274 0 0 0 1.057-.261l5.277-2.8A23.337 23.337 0 0 0 38 23.4V9.243a2.1 2.1 0 0 0-1.308-1.924zm-3.084 3.3V23.4a19.162 19.162 0 0 1-10.39 16.859L19 42.5l-4.22-2.239A19.158 19.158 0 0 1 4.393 23.4V10.618L19 4.418z"
								transform="translate(-290 -2064) translate(301 2071) translate(0 -.009)"
							/>
							<path
								fill="#003f87"
								d="M24.236 20.8H19.7v-4.538h-3.4V20.8h-4.545v3.4h4.539v4.541h3.4v-4.535h4.537z"
								transform="translate(-290 -2064) translate(301 2071) translate(1.245 .738)"
							/>
						</g>
					</g>
				</svg>
			);
		case "tax":
			return (
				<svg xmlns="http://www.w3.org/2000/svg" id="TB" width="60" height="60" viewBox="0 0 60 60" style={props.style}>
					<g id="Tax-_Exemption-G" transform="translate(13 9)">
						<path
							id="Path_980"
							d="M677.352 405.657v25.7a.769.769 0 0 1-.755.763h-26.44a.769.769 0 0 1-.755-.763v-34.351a.769.769 0 0 1 .755-.763h16.95a3.245 3.245 0 0 1 .94-2.188c-.441-.521-.832-.982-1.164-1.371h-16.726a4.306 4.306 0 0 0-4.28 4.322v34.355a4.306 4.306 0 0 0 4.28 4.322H676.6a4.306 4.306 0 0 0 4.28-4.322v-24.693l-1.49-1.782a3.178 3.178 0 0 1-2.038.771z"
							fill="#fc3f00"
							transform="translate(-645.877 -392.684)"
						/>
						<path
							id="Path_981"
							d="M696.437 409.081h-10.864a.218.218 0 0 1-.226-.2v-8.978l-.217-.222h-2.945c0 .032-.005.064-.005.1v9.1a3.2 3.2 0 0 0 3.394 2.952H696.482v-2.762a.24.24 0 0 1-.045.01z"
							fill="#fc3f00"
							transform="translate(-664.343 -396.138)"
						/>
						<path
							id="Path_985"
							d="M699.8 407.746a1.543 1.543 0 0 1-2.177-.148l-13.074-12.281a1.556 1.556 0 0 1 .147-2.185 1.544 1.544 0 0 1 2.177.147l13.073 12.281a1.556 1.556 0 0 1-.146 2.186z"
							fill="#fc3f00"
							transform="translate(-665.326 -392.718)"
						/>
						<rect id="Rectangle_687" width="3.506" height="14.94" fill="#003f87" rx="1.753" transform="rotate(41.43 -14.727 36.66)" />
						<circle id="Ellipse_137" cx="2.32" cy="2.32" r="2.32" fill="#003f87" transform="rotate(90 -1.717 25.681)" />
						<circle id="Ellipse_138" cx="2.32" cy="2.32" r="2.32" fill="#003f87" transform="rotate(90 -2.333 16.737)" />
					</g>
					<path id="Rectangle_1128" fill="none" d="M0 0H60V60H0z" />
				</svg>
			);
		case "goals":
			return (
				<svg xmlns="http://www.w3.org/2000/svg" id="KGT" width="60" height="60" viewBox="0 0 60 60" style={props.style}>
					<g id="Goals" transform="translate(7 8)">
						<path
							id="Path_1136"
							d="M29.311 17.335a1.892 1.892 0 0 0-1.891 1.891 8.194 8.194 0 1 1-8.194-8.194 1.891 1.891 0 0 0 0-3.782A11.976 11.976 0 1 0 31.2 19.226a1.892 1.892 0 0 0-1.889-1.891z"
							fill="#fc3f00"
							transform="translate(2.834 4.71)"
						/>
						<path
							id="Path_1137"
							d="M45.48 23.42a1.892 1.892 0 0 0-1.891 1.891A18.279 18.279 0 1 1 25.311 7.032a1.891 1.891 0 0 0 0-3.782 22.061 22.061 0 1 0 22.06 22.061 1.892 1.892 0 0 0-1.891-1.891z"
							fill="#fc3f00"
							transform="translate(-3.25 -1.374)"
						/>
						<g id="Group_3427" transform="translate(22.576)">
							<path id="Path_1138" d="M19.574 6.041l-.02-.01z" fill="#fc3f00" transform="translate(-1.017 2.849)" />
							<path
								id="Path_1139"
								fill="#003f87"
								d="M34.715 9.391l-3.81-1.9-.1-.05-.076-.041-.035-.076-.05-.1-1.906-3.81a1.6 1.6 0 0 0-.308-.426 1.653 1.653 0 0 0-2.335 0L19.381 9.7a1.632 1.632 0 0 0-.484 1.165V16.9l-.076.073-.1.1-6.058 6.061A1.65 1.65 0 0 0 15 25.462l6.053-6.053.1-.1.073-.073h6.033a1.638 1.638 0 0 0 1.167-.484l6.714-6.716a1.619 1.619 0 0 0 .31-.429 1.653 1.653 0 0 0-.735-2.216zm-3.771 2.179l-.328.33-3.865 3.862-.1.1-.073.073H22.2v-4.383l.073-.073.1-.1 3.865-3.862.328-.33.247-.247.159.313.207.416.852 1.7a1.644 1.644 0 0 0 .736.739l1.7.85.416.209.313.156z"
								transform="translate(-12.204 -2.506)"
							/>
						</g>
					</g>
					<path id="Rectangle_1129" fill="none" d="M0 0H60V60H0z" />
				</svg>
			);
		case "accumulate":
			return (
				<svg xmlns="http://www.w3.org/2000/svg" id="AW" width="60" height="60" viewBox="0 0 60 60" style={props.style}>
					<g id="Settlement_Options_" transform="translate(9 2)">
						<path
							id="Path_988"
							fill="#fc3f00"
							d="M54.587 66.345a4.362 4.362 0 0 0-1.657-2.506c-.24-9.9-3.77-17.66-9.344-20.724a1.513 1.513 0 0 0-.191-1.69 7.284 7.284 0 0 0 2.035-4.745 2.807 2.807 0 0 0-2.83-2.78 2.89 2.89 0 0 0-1.7.553l-.247.182-.451-.5a3.1 3.1 0 0 0-4.286 0l-.541.525-.256-.2a2.872 2.872 0 0 0-3.964.556 2.769 2.769 0 0 0-.565 1.7 7.245 7.245 0 0 0 2.031 4.708 1.53 1.53 0 0 0-.363.987 1.493 1.493 0 0 0 .19.731c-3.413 1.921-6.118 5.59-7.721 10.507-.14.015-.28.037-.415.063l-3.911.735v-1.316h-9v19.463h9v-1l14.062 5.516a4.563 4.563 0 0 0 1.644.313h.007a4.434 4.434 0 0 0 2.179-.553l13.5-5.423a4.512 4.512 0 0 0 2.794-5.102zM14.56 69.5V56.229h2.681V69.5zm23.469-33.083l.469.467a3.09 3.09 0 0 0 3.7.469 4.921 4.921 0 0 1-4.19 3.506 4.921 4.921 0 0 1-4.189-3.5 3.068 3.068 0 0 0 3.683-.438zm-.1-.083l.006-.007.007.007zm-.957 37.7l-.191.1a1.324 1.324 0 0 1-1.166.1L20.4 68.251V57.6l4.466-.851a2.654 2.654 0 0 1 1.648.224l16.351 7.983c-.1.235-.792.675-2.252.857a8.949 8.949 0 0 1-3.8-.333l-9.055-2.8-.948 2.96 9.032 2.764a10.608 10.608 0 0 0 3.64.572c.524-.009 1.058-.027 1.57-.085a8.073 8.073 0 0 0 3.04-.924l5.584-1.854a1.346 1.346 0 0 1 1.734.747c.022.058.042.119.047.133a1.443 1.443 0 0 1-.917 1.582zm.978-29.258a22.392 22.392 0 0 1 2.553.391c5.091 1.2 8.759 8.305 9.243 17.783a4.278 4.278 0 0 0-1.21.284l-2.636.857a3.106 3.106 0 0 0-1.78-2.021L27.9 54.179l-.019-.009c2.105-6.128 5.932-9.694 10.071-9.397z"
							transform="translate(-11.4 -22.422)"
						/>
						<path id="Rectangle_688" d="M0 0H3.504V7.205H0z" fill="#003f87" transform="translate(23.044)" />
						<path id="Rectangle_689" d="M0 0H7.232V3.504H0z" fill="#003f87" transform="rotate(-45 29.296 -35.71)" />
						<path id="Rectangle_690" d="M0 0H3.504V7.232H0z" fill="#003f87" transform="rotate(-45 13.27 -6.05)" />
					</g>
					<path id="Rectangle_1130" fill="none" d="M0 0H60V60H0z" />
				</svg>
			);
		case "loan":
			return (
				<svg xmlns="http://www.w3.org/2000/svg" id="AL" width="60" height="60" viewBox="0 0 60 60" style={props.style}>
					<g id="Portfolio" transform="translate(11 12)">
						<path id="Path_322" d="M-348.782 523.529v3.1H-383.1v-3.1" fill="#fc3f00" transform="translate(384.834 -505.074)" />
						<path
							id="Path_323"
							d="M-341.753 466.888h-15.709c-2.48 0-4.5-1.46-4.5-3.254V462.1c0-1.794 2.018-3.254 4.5-3.254h15.709c2.48 0 4.5 1.46 4.5 3.254v1.532c-.003 1.796-2.021 3.256-4.5 3.256zm-15.709-5.284c-.373 0-.688.228-.688.5v2.109c0 .27.315.5.688.5h15.709c.373 0 .688-.228.688-.5V462.1c0-.27-.315-.5-.688-.5z"
							fill="#003f87"
							transform="translate(368.655 -458.848)"
						/>
						<path
							id="Path_324"
							d="M-358.058 481.985h-28.107a5.135 5.135 0 0 0-4.946 5.295v21.1a5.135 5.135 0 0 0 4.946 5.294h28.107a5.135 5.135 0 0 0 4.947-5.294v-21.1a5.135 5.135 0 0 0-4.947-5.295zm1.1 25.666a1.878 1.878 0 0 1-1.807 1.9h-27.4c-.979 0-1.1-.869-1.1-1.9v-19.642c0-1.028.124-1.9 1.1-1.9h27.4a1.879 1.879 0 0 1 1.807 1.9z"
							fill="#fc3f00"
							transform="translate(391.112 -476.675)"
						/>
						<rect id="Rectangle_171" width="5.196" height="5.773" fill="#003f87" rx="2" transform="translate(16.041 17.332)" />
					</g>
					<path id="Rectangle_1131" fill="none" d="M0 0H60V60H0z" />
				</svg>
			);
		case "peace":
			return (
				<svg xmlns="http://www.w3.org/2000/svg" id="PM" width="60" height="60" viewBox="0 0 60 60" style={props.style}>
					<g id="peace" transform="translate(10 6)">
						<path
							id="Path_1140"
							d="M44.935-12.2a1.6 1.6 0 0 0 1.157.474 1.624 1.624 0 0 0 .983-.322 1.254 1.254 0 0 0 .172-1.9 2 2 0 0 1 .065-2.883 4.49 4.49 0 0 0 .421-6.156 1.54 1.54 0 0 0-.988-.544 1.647 1.647 0 0 0-1.131.237 1.261 1.261 0 0 0-.346 1.886 2 2 0 0 1-.186 2.744 4.488 4.488 0 0 0-.147 6.464z"
							fill="#003f87"
							transform="translate(-32.823 28.764)"
						/>
						<path
							id="Path_1141"
							d="M52.738-11.924a1.714 1.714 0 0 0 1.308.6 1.711 1.711 0 0 0 1.111-.409 1.723 1.723 0 0 0 .195-2.422 2.768 2.768 0 0 1 .072-3.664 6.221 6.221 0 0 0 .476-7.826 1.706 1.706 0 0 0-1.117-.693 1.709 1.709 0 0 0-1.281.3 1.722 1.722 0 0 0-.388 2.4 2.771 2.771 0 0 1-.213 3.487 6.21 6.21 0 0 0-.163 8.227z"
							fill="#003f87"
							transform="translate(-31.154 26.357)"
						/>
						<path
							id="Path_1142"
							fill="#fc3f00"
							d="M74.565 2.992a7.684 7.684 0 0 0-5.994-7.52v-.887a3 3 0 0 0-2.989-2.993H38.835a2.994 2.994 0 0 0-2.989 2.993V7.143a16.3 16.3 0 0 0 2.031 7.879h-1.309a2 2 0 0 0 0 4.009h31.281a2 2 0 0 0 0-4.009h-1.32a16.088 16.088 0 0 0 1.676-4.433 7.727 7.727 0 0 0 6.36-7.597zM68.571-.919a4.268 4.268 0 0 1 0 7.824zm-26.6 15.941a12.908 12.908 0 0 1-2.695-7.879V-4.971h25.862V7.143a12.9 12.9 0 0 1-2.706 7.879z"
							transform="translate(-34.565 29.969)"
						/>
					</g>
					<path id="Rectangle_1132" fill="none" d="M0 0H60V60H0z" />
				</svg>
			);
		case "coverage":
			return (
				<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" style={props.style}>
					<g>
						<path
							fill="#003f87"
							d="M33.648 58.3v6.147a1.477 1.477 0 0 1-1.474 1.474 1.461 1.461 0 0 1-1.474-1.474.75.75 0 0 0-1.5 0 2.973 2.973 0 0 0 5.947 0V58.3a5.49 5.49 0 0 0-.75.475 3.818 3.818 0 0 0-.749-.475z"
							transform="translate(-203 -3186.137) translate(183.045 3144.08)"
						/>
						<path
							fill="#fc3f00"
							d="M.476 16.894a.769.769 0 0 0 .8.1c.05-.025.125-.05.175-.075a4.363 4.363 0 0 1 4.4.575.749.749 0 0 0 .9 0 4.409 4.409 0 0 1 2.7-.924 4.357 4.357 0 0 1 2.7.924.788.788 0 0 0 .924 0 4.409 4.409 0 0 1 2.7-.924 4.357 4.357 0 0 1 2.7.924.75.75 0 0 0 .9 0 4.363 4.363 0 0 1 4.4-.575c.05.025.125.05.175.075a.769.769 0 0 0 .8-.1.742.742 0 0 0 .25-.775 12.676 12.676 0 0 0-11.594-9.57v-.5a.75.75 0 0 0-1.5 0v.5a12.839 12.839 0 0 0-11.68 9.57.758.758 0 0 0 .25.775zm12.168-8.87a11.341 11.341 0 0 1 10.545 7.146 7.11 7.11 0 0 0-1.024-.1 6.15 6.15 0 0 0-3.173.9 5.861 5.861 0 0 0-3.173-.9 6.15 6.15 0 0 0-3.173.9 5.861 5.861 0 0 0-3.173-.9 6.15 6.15 0 0 0-3.173.9 5.861 5.861 0 0 0-3.173-.9 4.6 4.6 0 0 0-1.024.1 11.341 11.341 0 0 1 10.541-7.146z"
							transform="translate(-203 -3186.137) translate(204.798 3183.837)"
						/>
					</g>
					<path fill="none" d="M0 0H28V28H0z" />
				</svg>
			);
		case "claims":
			return (
				<svg xmlns="http://www.w3.org/2000/svg" id="Claims" width="28" height="28" viewBox="0 0 28 28" style={props.style}>
					<g id="Component_55_1" transform="translate(1 7)">
						<g id="Group_951">
							<path
								id="Path_1002"
								d="M12.938 3.319A11.405 11.405 0 0 0 1.355 14.511c0 .08.021.157.023.237H24.5c0-.08.023-.157.023-.237A11.405 11.405 0 0 0 12.938 3.319z"
								fill="none"
								transform="translate(.562 -1.401)"
							/>
							<path
								id="Path_1003"
								fill="#fc3f00"
								d="M13.829 2.292a13.323 13.323 0 0 0-13.5 13.14c0 .081.017.158.019.238a13.177 13.177 0 0 0 .132 1.622h26.7a13.177 13.177 0 0 0 .132-1.621c0-.081.019-.158.019-.238A13.323 13.323 0 0 0 13.829 2.292zm11.546 13.379H2.283c0-.081-.023-.158-.023-.238A11.429 11.429 0 0 1 13.829 4.174 11.429 11.429 0 0 1 25.4 15.432c0 .081-.023.158-.025.239z"
								transform="translate(-.329 -2.292)"
							/>
							<g id="Group_950" transform="translate(10.239 5.732)">
								<path
									id="Path_1004"
									fill="#003f87"
									d="M6.687 14.7a.92.92 0 0 1-.529-.164.933.933 0 0 1-.241-1.3l5.033-7.314a.934.934 0 0 1 1.539 1.057L7.456 14.3a.935.935 0 0 1-.769.4z"
									transform="translate(-5.753 -5.517)"
								/>
							</g>
						</g>
					</g>
					<path id="Rectangle_1134" d="M0 0H28V28H0z" fill="none" />
				</svg>
			);
		case "premiums":
			return (
				<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" style={props.style}>
					<g>
						<path
							fill="#fc3f00"
							d="M11.459 2.021a9.438 9.438 0 1 1-9.438 9.438 9.448 9.448 0 0 1 9.438-9.438m0-1.562a11 11 0 1 0 11 11 11 11 0 0 0-11-11z"
							transform="translate(3 3) translate(-.459 -.459)"
						/>
						<path
							fill="#003f87"
							d="M12.437 6.634h-1.58V5.395h1.58a.681.681 0 1 0 0-1.362H5.689a.681.681 0 1 0 0 1.362h3.805v1.237H5.689a.682.682 0 1 0 0 1.368h3.58a3.2 3.2 0 0 1-.251.408 3.053 3.053 0 0 1-.416.416 3.014 3.014 0 0 1-.514.3 2.961 2.961 0 0 1-.579.158 8.464 8.464 0 0 1-.862.018h-.958a.686.686 0 0 0-.682.68v.1a.7.7 0 0 0 .2.49l.023.021.116.117.473.482 1.532 1.554 1.585 1.606.758.768a.681.681 0 1 0 .963-.963l-.719-.729-1.572-1.594-1.155-1.17c.075 0 .148 0 .223-.011a3.657 3.657 0 0 0 3.057-2.06A4.165 4.165 0 0 0 10.717 8h1.72a.682.682 0 0 0 0-1.363z"
							transform="translate(3 3) translate(1.937 1.327)"
						/>
					</g>
					<path fill="none" d="M0 0H28V28H0z" />
				</svg>
			);
		default:
			return <>No Icon</>;
	}
}
